export var TimelineState = /*#__PURE__*/ function(TimelineState) {
    TimelineState["WaitingToStart"] = "WaitingToStart";
    TimelineState["Started"] = "Started";
    TimelineState["Ended"] = "Ended";
    return TimelineState;
}({});
export var TimelineItemType = /*#__PURE__*/ function(TimelineItemType) {
    TimelineItemType["MainContent"] = "MainContent";
    TimelineItemType["Advert"] = "Advert";
    return TimelineItemType;
}({});

//# sourceMappingURL=timeline.enums.js.map